import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@mui/material';

const DeletePost = ({ show, onHide, onDelete }) => {
  return (
    <Dialog data-cy="delete-modal" open={show} onClose={onHide}>
      <DialogTitle>Delete Post?</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this post?</DialogContentText>
      </DialogContent>
      <DialogActions className="gap-2">
        <Button onClick={onHide}>Cancel</Button>
        <Button
          data-cy="delete-button-confirm"
          variant="contained"
          color="error"
          onClick={onDelete}
          data-testid="delete-button"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePost;
